(() => {
	'use strict';

	const initTabs = () => {
		const tabs = document.querySelectorAll('.js-tab-button');
		if (!tabs.length) return;

		tabs.forEach((tab, index) => {
			const tablist = tab.closest('[role="tablist"]');
			const allTabs = tablist.querySelectorAll('[role="tab"]');

			tab.addEventListener('click', () => {
				const panels = document.querySelectorAll('[role="tabpanel"]');

				allTabs.forEach((t) => {
					t.setAttribute('aria-selected', 'false');
					t.setAttribute('tabindex', '-1');
				});

				panels.forEach((p) => {
					p.hidden = true;
				});

				tab.setAttribute('aria-selected', 'true');
				tab.setAttribute('tabindex', '0');

				const panel = document.getElementById(tab.getAttribute('aria-controls'));
				if (panel) panel.hidden = false;
			});

			tab.addEventListener('keydown', (e) => {
				let newIndex = index;

				if (e.key === 'ArrowRight') newIndex = (index + 1) % allTabs.length;
				if (e.key === 'ArrowLeft') newIndex = (index - 1 + allTabs.length) % allTabs.length;

				if (newIndex !== index) {
					allTabs[newIndex].focus();
					allTabs[newIndex].click();
				}
			});
		});
	};

	const initFloatCTA = () => {
		const target = document.getElementById('js-float-cta');
		const footerSection = document.querySelector('.footer');

		if (!target || !footerSection) return;

		const handleScroll = () => {
			const scrollY = window.scrollY;
			const scrollBottom = scrollY + window.innerHeight;
			const contactTop = footerSection.offsetTop;

			const isShow = scrollY > 200 && scrollBottom < contactTop;

			target.classList.toggle('is-active', isShow);
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
	};

	// 初期化
	const init = () => {
		initTabs();
		initFloatCTA();
	};

	document.addEventListener('DOMContentLoaded', init);
})();
